import React from 'react';

import { Card, CardBody } from 'Components/Card';
import { PrimaryButton } from 'Components/Button';

import PollsApi from 'Services/Api/MainStage/Poll';
import { Alert } from 'Components/Partials';

import { translation } from 'Services/TranslationHelpers';

export default class Poll extends React.Component {
    /**
     * @var containerRef
     * @type {null|HTMLDivElement}
     */
    containerRef = null;

    /**
     * @var titleRef
     * @type {null|HTMLDivElement}
     */
    titleRef = null;

    /**
     * @var formRef
     * @type {null|HTMLDivElement}
     */
    footerRef = null;

    /**
     * @var state
     * @type {{alert: null, working: boolean, submission: null, vote: null}}
     */
    state = {
        vote: null,
        working: false,
        alert: null,
        submission: null,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        if (this.props.poll) {
            this.fetchSubmission();
        }

        if (window.base.main_stage.layout === 'tabs') {
            this.setSize();
        }
    };

    /**
     * @method componentDidUpdate
     * @param {object} prevProps
     */
    componentDidUpdate = (prevProps) => {
        if (window.base.main_stage.layout === 'tabs' && prevProps.height !== this.props.height) {
            this.setSize();
        }

        if (prevProps.poll !== this.props.poll) {
            this.fetchSubmission();
        }
    };

    /**
     * @method setSize
     */
    setSize = () => {
        if (!this.containerRef) {
            return;
        }

        this.containerRef.style.height = `${this.props.height - (this.footerRef ? this.footerRef.clientHeight : 0) - this.titleRef.clientHeight - 48}px`;
    };

    /**
     * @method fetchSubmission
     * @return {Promise<void>}
     */
    fetchSubmission = async () => {
        const request = await PollsApi.get({
            session: this.props.sessionId,
        }, {
            poll_id: this.props.poll.id,
        });

        return this.setState({
            submission: request.success ? request.data.data : null,
        });
    };

    /**
     * @method handleVote
     * @param {string} vote
     */
    handleVote = (vote) => {
        this.setState({
            vote,
        });
    };

    /**
     * @method handleSubmitVote
     * @return {Promise<void>}
     */
    handleSubmitVote = async () => {
        this.setState({ working: true });

        const request = await PollsApi.post({
            session: this.props.sessionId,
        }, {
            poll_id: this.props.poll.id,
            answer_id: this.state.vote,
        });

        if (request.success) {
            return this.setState({
                alert: {
                    type: 'success',
                    message: translation('main_stage_frontend', 'thank_you_for_submission'),
                },
                working: false,
                submission: request.data.data,
            });
        }

        this.setState({
            alert: {
                type: 'error',
                message: translation('main_stage_frontend', 'submission_problem'),
                errors: request.errors,
            },
            working: false,
        });
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { poll } = this.props;
        const { vote, working, alert, submission } = this.state;

        if (!poll) {
            return (
                <Card className="h-full bg-gray-200">
                    <CardBody className="h-full flex flex-col">
                        <h1 className="text-2xl font-bold" ref={ref => this.titleRef = ref}>
                            {translation('main_stage_frontend', 'no_polls')}
                        </h1>
                    </CardBody>
                </Card>
            );
        }

        return (
            <Card className="h-full bg-gray-200">
                <CardBody className="h-full flex flex-col">
                    <h1 className="text-2xl font-bold" ref={ref => this.titleRef = ref}>
                        {poll.question}
                    </h1>

                    <div ref={ref => this.containerRef = ref} className="overflow-y-auto">
                        {alert !== null && (<Alert {...alert} />)}

                        {poll.answers.map(a => (
                            <div className="relative p-4 flex" key={a.id}>
                                <div className="flex items-center h-5">
                                    <input
                                        id={`vote-${a.id}`}
                                        type="radio"
                                        className={`focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 ${submission ? '' : 'cursor-pointer'}`}
                                        checked={a.id === vote || (submission !== null && submission.answer_id === a.id)}
                                        onChange={() => this.handleVote(a.id)}
                                        disabled={submission !== null}
                                    />
                                </div>
                                <label htmlFor={`vote-${a.id}`}
                                       className={`ml-3 flex flex-col ${submission ? '' : 'cursor-pointer'}`}>
                                <span className="block text-sm font-medium">
                                    {a.answer}
                                </span>
                                </label>
                            </div>
                        ))}
                    </div>

                    <div ref={ref => this.footerRef = ref} className="flex justify-end">
                        <PrimaryButton
                            onClick={this.handleSubmitVote}
                            disabled={!vote || submission}
                            working={working}
                            text={translation('main_stage_frontend', 'vote')}
                        />
                    </div>
                </CardBody>
            </Card>
        );
    }
}
